var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-form',{attrs:{"action-type":"create","list-value-data":_vm.listValueData,"submit-button-disabled":_vm.submitButtonDisabled,"loading":_vm.loading},on:{"save":_vm.createList,"updateListItems":_vm.updateListItems}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc3d389c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/ListsSettings/NewCustomList.vue
// module id = null
// module chunks = 